import React, { useEffect, useState, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import "../CssCNF/ClientNavbar.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { MdLogout } from "react-icons/md";
// import LoadingSpinner from "../Loading/LoadingSpinner";

const AllPagesNavbar = () => {
  const sessiontoken = window.sessionStorage.getItem("session-token");

  const navigate = useNavigate();
  const navbarRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const module = useSelector((state) => state.SelModule);
  // console.log(module);
  const state = useSelector((state) => state.changeTheState);
  const userName = state?.user?.emailId?.split("@")[0].toUpperCase();
  const email = state?.user?.emailId;
  // const modulename = state?.user?.userName;
  const modulename = module?.selectedModule;

  const dashboardPageTracker = useSelector(
    (state) => state?.dashboardPageTrackerReducer
  );
  const select = useSelector((state) => state.SelCompany);
  const selectedCompany = select?.selectedCompany;
  const [clientname, setClientname] = useState("");
  const BASEURL = process.env.REACT_APP_BASEURL;
    const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
        const [companyName,setCompanyName] = useState("")
  const authToken = window.sessionStorage.getItem("auth-token");
  const [isloading, setIsLoading] = useState(true);
  const [ModuleAccess, setModuleAccess] = useState([]);
  useEffect(() => {
    // axios
    //   .get(
    //     `${BASEURL}/getClientCode?EMAIL ADDRESS=${email}`,
    //     // {
    //     //   EMAIL: email,
    //     // },
    //     {
    //       headers: {
    //         "auth-token": authToken,
    //         "session-token": sessiontoken,
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     axios
    //       .post(
    //         `${BASEURL}/getCLientDetails`,
    //         {
    //           CLIENTCODE: response?.data[0]?.["CLIENT CODE"],
    //         },
    //         {
    //           headers: {
    //             "auth-token": authToken,
    //             "session-token": sessiontoken,
    //           },
    //         }
    //       )
    //       .then((response) => {
    //         setIsLoading(false);
    //         setClientname(response?.data[0]?.CLIENTNAME);
    //       })
    //       .catch((err) => {
    //         setIsLoading(false);
    //         console.log("error while fetching client details", err);
    //       });
    //   })
    //   .catch((error) => {
    //     setIsLoading(false);
    //     console.log("error fetching client code details", error);
    //   });
    
             // ORG NAME
  axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCompanyName(res?.data[0]?.ORGNAME);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error while fetching /viewname=602", err);
      });
    
  }, []);

  const [openGroup, setOpenGroup] = useState(null);

  const handleGroupClick = (index) => {
    setOpenGroup(openGroup === index ? null : index);
  };

  function AuthorizseUserLogin() {
    setIsLoading(true);
    axios
      .post(
        `${BASEURL}/getuserrights`,
        {
          EMAIL: email,
          MODULENAME: "LOGISTICS TRACKING",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((response) => {
        setModuleAccess(response.data.recordsets[0]);
        setIsLoading(false);
      });
  }
  useEffect(() => {
    AuthorizseUserLogin();
  }, []);
  const dispatch = useDispatch();
  // function logOut() {
  //   navigate("/");
  //   dispatch(logIn([]));
  // }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // setIsDeliveryNoteClicked(false);
  };

  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuClick = (menuName) => {
    if (openMenu === menuName) {
      setOpenMenu(null);
    } else {
      setOpenMenu(menuName);
    }
  };
  const handleNavigation = (page) => {
    navigate(`/${page.link}`, { state: { menu: page.menu } });
  };

  useEffect(() => {
    ///menu close anywhere click
    const handleOutsideClick = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  // if (isloading) {
  //   return <LoadingSpinner />;
  // }

  return (
    <nav className="centernav" ref={navbarRef}>
      <div className="navbar-container uppercase">
        <nav className="navbar">
          <div className="">
            <div className="fabar" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
          <ul
            className={`nav-menu ${isMenuOpen ? "open" : ""}`}
            style={{ textTransform: "uppercase" }}
          >
            {/* <li className="nav-item">Men</li> */}

            <div className="hover-dropdown">
              {/* <span className="master-select-opt hover-underline-animation">
                <label className="transaction-select hover-underline-animation">
                  {ModuleAccess.length > 0 ? "Menu" : "Scanner Application"}
                </label>
              </span> */}
              <ul className="ul__list__style__scanner">
                {isloading && "Loading...."}
                {ModuleAccess.length === 0 ? (
                  <div>
                    <li>NO RIGHTS</li>
                  </div>
                ) : null}

                <aside>
                  {ModuleAccess.reduce((acc, item, index) => {
                    // Check if MENU_TYPE already exists in the accumulator
                    const existingType = acc.find(
                      (group) => group.type === item.OM_ACCOUNT_MODULE_MENU_TYPE
                    );

                    if (existingType) {
                      // If MENU_TYPE exists, add the current ID to its list
                      if (typeof item === "object") {
                        existingType.ids.push({
                          name: item.OM_ACCOUNT_MODULE_MENU_DISPLAY_NAME,
                          link: item.OM_ACCOUNT_MODULE_WEB_PAGE,
                          menu: item.OM_ACCOUNT_MODULE_MENU,
                        });
                        existingType.weblink.push(
                          item.OM_ACCOUNT_MODULE_WEB_PAGE
                        );
                      } else {
                        existingType.ids.push(item);
                        existingType.weblink.push(existingType.weblink[index]);
                      }
                    } else {
                      // If MENU_TYPE doesn't exist, create a new group with the current ID
                      const newId =
                        typeof item === "object"
                          ? {
                              name: item.OM_ACCOUNT_MODULE_MENU_DISPLAY_NAME,
                              link: item.OM_ACCOUNT_MODULE_WEB_PAGE,
                              menu: item.OM_ACCOUNT_MODULE_MENU,
                            }
                          : item;

                      acc.push({
                        type: item.OM_ACCOUNT_MODULE_MENU_TYPE,
                        ids: [newId],
                        weblink: [item.OM_ACCOUNT_MODULE_WEB_PAGE],
                      });
                    }
                    return acc;
                  }, []).map((group, index) => (
                    <div key={index} style={{ fontSize: "14px" }}>
                      <p
                        style={{
                          cursor: "pointer",
                          paddingBottom: "0px",
                          marginBottom: "0px",
                        }}
                        onClick={() => handleGroupClick(index)}
                      >
                        {group.type}
                      </p>

                      {openGroup === index && (
                        <ul
                          style={{ listStyleType: "none", paddingLeft: "15px" }}
                        >
                          {group.ids.map((id, idIndex) => (
                            <li key={idIndex} style={{ cursor: "pointer" }}>
                              {typeof id === "object" && (
                                <span
                                  style={{
                                    textDecoration: "none",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleNavigation(id)}
                                >
                                  {id.name}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </aside>
              </ul>
            </div>
            {/* Hardcoded menu at the end */}
          </ul>
          {/* <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
            <div className="hover-dropdown">
              <ul className="ul__list__style__scanner">
                <div>
                  <p
                    onClick={() => {
                      navigate("/TrafficAndRoadInfo");
                    }}
                  >
                    Traffic And Road Info
                  </p>
                </div>
              </ul>
            </div>
          </ul> */}
        </nav>
        <div className="logedIn__as__btn">
          <h2>
            {" "}
             WELCOME TO ({companyName})
          </h2>
          <h3 className="hidden lg:block">
            Logged in as : {userName ? userName : "N/A"}
          </h3>
          {/* {state.emailId.split("@")[0].toUpperCase()}</h3> */}
        </div>

        <aside>
          <button
            onClick={() => {
              navigate("/Dashboard");
            }}
            className="button__logout__navbar"
          >
            DASHBOARD
          </button>
        </aside>
        <div className="logout__fullscren">
          <button
            onClick={() => {
              navigate("/Dashboard");
            }}
            className="log__out__icon"
          >
            {" "}
            <FiLogOut />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AllPagesNavbar;
